// extracted by mini-css-extract-plugin
export default {"bordered":"style_bordered__s6K8b","image":"style_image__lPNTU"};